import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgSave(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M15 0l5 4.998V15a1 1 0 01-1 1H5a1 1 0 01-1-1V1a1 1 0 011-1zm3 9H6v5h11a1 1 0 00.993-.883L18 13zM8 2H6v4.29h7.984V2H12v2.068c0 .237-.08.463-.237.63a.8.8 0 01-.479.248l-.109.007H8.824a.793.793 0 01-.588-.255.889.889 0 01-.23-.513L8 4.068z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Save')(SvgSave);
